import { updateImageConnexion } from '@/api/imageConnexion/index';

export default async function updateImage(pieceJointe) {
  const formdata = new FormData();
  formdata.append('attachments0', pieceJointe.file);
  formdata.append('data', JSON.stringify(pieceJointe));
  const response = await updateImageConnexion(formdata);
  return response.data.result;
}
